import Navihome from "./navHome.js"

const NavigationNav = () => {
    return (
        <Navihome/>
    );
};

export default NavigationNav;